<rfid-card-manager>
  <div class="rfid-card-manager">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">
          <i class="bi bi-credit-card-2-front me-2"></i>
          Tarjetas RFID
        </h5>
        <div>
          <button class="btn btn-sm btn-outline-primary app-btn app-btn-sm me-2" onclick={downloadTemplate}>
            <i class="bi bi-download me-1"></i>
            Descargar Plantilla CSV
          </button>
          <button class="btn btn-sm btn-success app-btn app-btn-sm me-2" onclick={showBulkUploadModal}>
            <i class="bi bi-file-earmark-arrow-up me-1"></i>
            Carga Masiva
          </button>
          <button class="btn btn-sm btn-primary app-btn app-btn-sm" onclick={showAddCardModal}>
            <i class="bi bi-plus-circle me-1"></i>
            Añadir Tarjeta
          </button>
        </div>
      </div>

      <div class="card-body">
        <!-- Búsqueda y filtros -->
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-search"></i>
              </span>
              <input
                type="text"
                class="form-control"
                placeholder={state.isAdmin
                  ? 'Buscar por serie, número impreso, titular o cuenta...'
                  : 'Buscar por serie, número impreso o usuario...'}
                value={state.searchTerm}
                oninput={handleSearch}
              />
            </div>
          </div>
          <div class="col-md-6">
            <div if={state.isAdmin}>
              <label class="form-label small text-muted mb-1">Filtrar por cuenta propietaria</label>
              <select class="form-select" value={state.selectedUserId} onchange={handleUserFilterChange}>
                <option value="">Todos los usuarios</option>
                <option each={user in state.users} value={user._id} key={user._id}>
                  {user.username} ({user.email}) · {user._id}
                </option>
              </select>
            </div>
            <div if={!state.isAdmin} class="text-end pt-2">
              <span class="text-muted">
                Total: {state.filteredCards.length} tarjeta(s)
              </span>
            </div>
          </div>
        </div>

        <div if={state.isAdmin} class="d-flex justify-content-end mb-3">
          <span class="text-muted">
            Total: {state.filteredCards.length} tarjeta(s)
          </span>
        </div>

        <div if={state.isAdmin && !state.loadingUsers && state.users.length === 0} class="alert alert-warning">
          No se pudieron cargar usuarios para la gestión global de tarjetas RFID.
        </div>

        <div if={state.isAdmin && !state.selectedUserId} class="alert alert-secondary py-2">
          Estás viendo tarjetas de <strong>todos los usuarios</strong>. En los formularios podés elegir el propietario.
        </div>

        <!-- Loading -->
        <div if={state.loading} class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>

        <!-- Tabla de tarjetas -->
        <div if={!state.loading && state.filteredCards.length > 0} class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th if={state.isAdmin}>Cuenta Propietaria</th>
                <th>Número de Serie</th>
                <th>Número Impreso</th>
                <th>Usuario</th>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Último Uso</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr each={card in state.filteredCards} key={card._id}>
                <td if={state.isAdmin}>
                  <div class="small fw-semibold">{card.owner?.username || '-'}</div>
                  <div class="text-muted small">{card.owner?.email || card.owner?._id || '-'}</div>
                </td>
                <td>
                  <code>{card.cardNumber}</code>
                </td>
                <td>
                  <span if={state.editingCardId !== card._id}>{card.userNumber}</span>
                  <input
                    if={state.editingCardId === card._id}
                    type="text"
                    class="form-control form-control-sm"
                    data-edit-user-number="true"
                    value={state.editingCardUserNumber}
                    oninput={e => updateEditingField('editingCardUserNumber', e.target.value)}
                  />
                </td>
                <td>
                  <span if={state.editingCardId !== card._id}>{card.userName}</span>
                  <input
                    if={state.editingCardId === card._id}
                    type="text"
                    class="form-control form-control-sm"
                    data-edit-user-name="true"
                    value={state.editingCardUserName}
                    oninput={e => updateEditingField('editingCardUserName', e.target.value)}
                  />
                </td>
                <td>
                  <span class={'badge ' + (card.enabled ? 'bg-success' : 'bg-secondary')}>
                    {card.enabled ? 'Activa' : 'Inactiva'}
                  </span>
                </td>
                <td>{formatDate(card.date)}</td>
                <td>{card.lastUsed ? formatRelativeTime(card.lastUsed) : 'Nunca'}</td>
                <td class="text-center table-actions-cell">
                  <div class="btn-group table-action-group" role="group" aria-label="Acciones de la tarjeta RFID">
                    <button
                      if={state.editingCardId !== card._id}
                      class="btn btn-sm table-action-btn table-action-edit"
                      data-card-id={card._id}
                      onclick={startEdit}
                      title="Editar tarjeta"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      if={state.editingCardId === card._id}
                      class="btn btn-sm table-action-btn table-action-save"
                      data-card-id={card._id}
                      onclick={saveEdit}
                      title="Guardar"
                    >
                      <i class="bi bi-check"></i>
                    </button>
                    <button
                      if={state.editingCardId === card._id}
                      class="btn btn-sm table-action-btn table-action-cancel"
                      onclick={cancelEdit}
                      title="Cancelar"
                    >
                      <i class="bi bi-x"></i>
                    </button>
                    <button
                      class={'btn btn-sm table-action-btn ' + (card.enabled ? 'table-action-disable' : 'table-action-enable')}
                      data-card-id={card._id}
                      onclick={toggleCard}
                      title={card.enabled ? 'Desactivar' : 'Activar'}
                    >
                      <i class={'bi bi-' + (card.enabled ? 'pause-circle' : 'play-circle')}></i>
                    </button>
                    <button
                      class="btn btn-sm table-action-btn table-action-delete"
                      data-card-id={card._id}
                      onclick={confirmDelete}
                      title="Eliminar"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty state -->
        <div if={!state.loading && state.filteredCards.length === 0} class="text-center py-5">
          <i class="bi bi-credit-card text-muted" style="font-size: 4rem;"></i>
          <p class="text-muted mt-3">
            {state.searchTerm ? 'No se encontraron tarjetas con ese criterio' : 'No hay tarjetas RFID registradas'}
          </p>
          <button if={!state.searchTerm} class="btn btn-primary app-btn app-btn-md" onclick={showAddCardModal}>
            <i class="bi bi-plus-circle me-1"></i>
            Añadir Primera Tarjeta
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Añadir Tarjeta -->
    <div class="modal fade" id="addCardModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Añadir Tarjeta RFID</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form onsubmit={handleAddCard} novalidate>
              <div class="mb-3">
                <label if={state.isAdmin} class="form-label">Cuenta propietaria *</label>
                <select
                  if={state.isAdmin}
                  class={'form-select' + (state.errors['targetUserId'] ? ' is-invalid' : '')}
                  value={state.newCard.targetUserId}
                  onchange={e => updateNewCard('targetUserId', e.target.value)}
                >
                  <option value="">Selecciona un usuario</option>
                  <option each={user in state.users} value={user._id} key={user._id}>
                    {user.username} ({user.email}) · {user._id}
                  </option>
                </select>
                <div class="invalid-feedback" if={state.errors['targetUserId']}>{state.errors['targetUserId']}</div>
              </div>
              <div class="mb-3">
                <label class="form-label">Número de Serie *</label>
                <input
                  type="text"
                  class={'form-control' + (state.errors['cardNumber'] ? ' is-invalid' : '')}
                  value={state.newCard.cardNumber}
                  oninput={e => updateNewCard('cardNumber', e.target.value)}
                  placeholder="Ej: 123456789"
                />
                <div class="invalid-feedback" if={state.errors['cardNumber']}>{state.errors['cardNumber']}</div>
              </div>
              <div class="mb-3">
                <label class="form-label">Número Impreso *</label>
                <input
                  type="text"
                  class={'form-control' + (state.errors['userNumber'] ? ' is-invalid' : '')}
                  value={state.newCard.userNumber}
                  oninput={e => updateNewCard('userNumber', e.target.value)}
                  placeholder="Ej: 001"
                />
                <div class="invalid-feedback" if={state.errors['userNumber']}>{state.errors['userNumber']}</div>
              </div>
              <div class="mb-3">
                <label class="form-label">Nombre de Usuario *</label>
                <input
                  type="text"
                  class={'form-control' + (state.errors['userName'] ? ' is-invalid' : '')}
                  value={state.newCard.userName}
                  oninput={e => updateNewCard('userName', e.target.value)}
                  placeholder="Ej: Enrique"
                />
                <div class="invalid-feedback" if={state.errors['userName']}>{state.errors['userName']}</div>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="enabledCheck"
                  checked={state.newCard.enabled}
                  onchange={e => updateNewCard('enabled', e.target.checked)}
                />
                <label class="form-check-label" for="enabledCheck">
                  Tarjeta habilitada
                </label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary app-btn app-btn-md" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary app-btn app-btn-md" onclick={handleAddCard} disabled={state.saving}>
              {state.saving ? 'Guardando...' : 'Añadir Tarjeta'}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Carga Masiva -->
    <div class="modal fade" id="bulkUploadModal" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Carga Masiva de Tarjetas RFID</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <rfid-bulk-upload
              userId={getDefaultTargetUserId()}
              defaultUserId={getDefaultTargetUserId()}
              isAdmin={state.isAdmin}
              users={state.users}
              onUploadComplete={handleBulkUploadComplete}
            ></rfid-bulk-upload>
          </div>
        </div>
      </div>
    </div>
  </div>

  <script>
    import { RfidCardService, UserService, AuthService } from '../services/api';
    import { ToastService } from '../services/toast-service';
    import { Modal } from 'bootstrap';
    import RfidBulkUpload from './rfid-bulk-upload.riot';

    export default {
      components: {
        RfidBulkUpload
      },

      onBeforeMount(props) {
        this._isInitializing = false;
        this._initializedUserId = null;

        this.state = {
          cards: [],
          filteredCards: [],
          loading: false,
          loadingUsers: false,
          saving: false,
          searchTerm: '',
          users: [],
          isAdmin: false,
          selectedUserId: '',
          editingCardId: null,
          editingCardUserNumber: '',
          editingCardUserName: '',
          newCard: {
            targetUserId: '',
            cardNumber: '',
            userNumber: '',
            userName: '',
            enabled: true
          },
          errors: {},
          hasLoadedOnce: false
        };
      },

      async onMounted() {
        await this.initialize();
      },

      onUpdated() {
        if (!this.props.userId) {
          return;
        }

        if (this._isInitializing) {
          return;
        }

        if (this.props.userId !== this._initializedUserId) {
          this.initialize();
        }
      },

      async initialize() {
        if (!this.props.userId || this._isInitializing) {
          return;
        }

        this._isInitializing = true;

        try {
          const isAdmin = this.props.isAdmin ?? AuthService.isAdmin();
          this.update({
            isAdmin,
            selectedUserId: isAdmin ? this.state.selectedUserId : this.props.userId,
            newCard: {
              ...this.state.newCard,
              targetUserId: isAdmin
                ? (this.state.newCard.targetUserId || this.state.selectedUserId || this.props.userId)
                : this.props.userId
            }
          });

          if (isAdmin) {
            await this.loadUsers();
          }

          await this.loadCards();
          this._initializedUserId = this.props.userId;
        } finally {
          this._isInitializing = false;
        }
      },

      async loadUsers() {
        try {
          this.update({ loadingUsers: true });
          const users = await UserService.getUsers();
          const fallbackUserId = this.state.selectedUserId || this.props.userId || '';
          this.update({
            users: users || [],
            loadingUsers: false,
            selectedUserId: this.state.selectedUserId,
            newCard: {
              ...this.state.newCard,
              targetUserId: this.state.newCard.targetUserId || fallbackUserId
            }
          });
        } catch (error) {
          console.error('Error loading users:', error);
          ToastService.error('Error al cargar usuarios para gestión RFID');
          this.update({ loadingUsers: false });
        }
      },

      async loadCards() {
        const isAdmin = this.state.isAdmin || this.props.isAdmin;
        if (!this.props.userId && !isAdmin) {
          console.warn('Cannot load cards: userId is not set');
          return;
        }

        try {
          this.update({ loading: true, hasLoadedOnce: true });
          const cards = isAdmin
            ? await RfidCardService.getAllCards()
            : await RfidCardService.getCards(this.props.userId);
          this.update({
            cards,
            loading: false
          });
          this.applyFilters(cards, this.state.searchTerm, this.state.selectedUserId);
        } catch (error) {
          console.error('Error loading cards:', error);
          ToastService.error('Error al cargar tarjetas RFID');
          this.update({ loading: false });
        }
      },

      applyFilters(cards = this.state.cards, searchTerm = this.state.searchTerm, selectedUserId = this.state.selectedUserId) {
        const normalizedSearch = (searchTerm || '').toLowerCase().trim();

        const filteredCards = (cards || []).filter(card => {
          const matchesUserFilter = !this.state.isAdmin || !selectedUserId || card.owner?._id === selectedUserId;
          if (!matchesUserFilter) {
            return false;
          }

          if (!normalizedSearch) {
            return true;
          }

          const haystack = [
            card.cardNumber,
            card.userNumber,
            card.userName,
            card.owner?._id,
            card.owner?.username,
            card.owner?.email
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

          return haystack.includes(normalizedSearch);
        });

        this.update({
          searchTerm,
          selectedUserId,
          filteredCards
        });
      },

      handleSearch(e) {
        this.applyFilters(this.state.cards, e.target.value, this.state.selectedUserId);
      },

      handleUserFilterChange(e) {
        this.applyFilters(this.state.cards, this.state.searchTerm, e.target.value);
      },

      showAddCardModal() {
        this.update({
          errors: {},
          newCard: {
            targetUserId: this.getDefaultTargetUserId(),
            cardNumber: '',
            userNumber: '',
            userName: '',
            enabled: true
          }
        });
        const modalElement = document.getElementById('addCardModal');
        if (modalElement) {
          const modal = new Modal(modalElement);
          modal.show();
        }
      },

      showBulkUploadModal() {
        if (this.state.isAdmin && !this.state.users.length) {
          ToastService.error('No hay usuarios disponibles para asignar la carga masiva');
          return;
        }

        console.log('Opening bulk upload modal for userId:', this.props.userId);
        const modalElement = document.getElementById('bulkUploadModal');
        if (modalElement) {
          const modal = new Modal(modalElement);
          modal.show();
        }
      },

      updateNewCard(field, value) {
        this.update({
          errors: this.clearError(field),
          newCard: {
            ...this.state.newCard,
            [field]: value
          }
        });
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors;
        }

        const errors = { ...this.state.errors };
        delete errors[name];
        return errors;
      },

      validateNewCard() {
        const errors = {};

        if (this.state.isAdmin && !this.state.newCard.targetUserId) {
          errors.targetUserId = 'Selecciona el usuario propietario de la tarjeta';
        }

        if (!this.state.newCard.cardNumber || !this.state.newCard.cardNumber.trim()) {
          errors.cardNumber = 'El número de serie es obligatorio';
        }

        if (!this.state.newCard.userNumber || !this.state.newCard.userNumber.trim()) {
          errors.userNumber = 'El número impreso es obligatorio';
        }

        if (!this.state.newCard.userName || !this.state.newCard.userName.trim()) {
          errors.userName = 'El nombre de usuario es obligatorio';
        }

        this.update({ errors });

        if (Object.keys(errors).length > 0) {
          ToastService.error('Revisá los campos marcados en rojo');
          return false;
        }

        return true;
      },

      updateEditingField(field, value) {
        this.update({ [field]: value });
      },

      getDefaultTargetUserId() {
        return this.state.selectedUserId || this.props.userId || '';
      },

      getCardOwnerId(card) {
        return card?.owner?._id || this.props.userId || '';
      },

      async handleAddCard(e) {
        e.preventDefault();

        if (!this.validateNewCard()) {
          return;
        }

        const targetUserId = this.state.isAdmin
          ? this.state.newCard.targetUserId
          : this.props.userId;

        if (!targetUserId) {
          ToastService.error('No se pudo determinar el usuario propietario de la tarjeta');
          return;
        }

        try {
          this.update({ saving: true });
          await RfidCardService.addCard(targetUserId, {
            cardNumber: this.state.newCard.cardNumber,
            userNumber: this.state.newCard.userNumber,
            userName: this.state.newCard.userName,
            enabled: this.state.newCard.enabled
          });
          ToastService.success('Tarjeta añadida correctamente');

          // Cerrar modal
          const modalElement = document.getElementById('addCardModal');
          if (modalElement) {
            const modal = Modal.getInstance(modalElement);
            if (modal) {
              modal.hide();
            }
          }

          // Recargar lista
          await this.loadCards();
        } catch (error) {
          console.error('Error adding card:', error);
          ToastService.error(error.message || 'Error al añadir tarjeta');
        } finally {
          this.update({ saving: false });
        }
      },

      getCardById(cardId) {
        return this.state.cards.find(card => card._id === cardId) || null;
      },

      startEdit(event) {
        const cardId = event?.currentTarget?.dataset?.cardId;
        const card = this.getCardById(cardId);
        if (!card) {
          return;
        }

        this.update({
          editingCardId: card._id,
          editingCardUserNumber: card.userNumber,
          editingCardUserName: card.userName
        });
      },

      cancelEdit() {
        this.update({
          editingCardId: null,
          editingCardUserNumber: '',
          editingCardUserName: ''
        });
      },

      async saveEdit(event) {
        try {
          const cardId = event?.currentTarget?.dataset?.cardId;
          if (!cardId) {
            ToastService.error('No se pudo identificar la tarjeta a actualizar');
            return;
          }

          const card = this.getCardById(cardId);
          const ownerId = this.getCardOwnerId(card);
          if (!ownerId) {
            ToastService.error('No se pudo identificar el propietario de la tarjeta');
            return;
          }

          const rowElement = event?.currentTarget?.closest('tr');
          const userNumberInput = rowElement?.querySelector('[data-edit-user-number="true"]');
          const userNameInput = rowElement?.querySelector('[data-edit-user-name="true"]');

          const userNumber = (userNumberInput?.value ?? this.state.editingCardUserNumber).trim();
          const userName = (userNameInput?.value ?? this.state.editingCardUserName).trim();

          if (!userNumber || !userName) {
            ToastService.error('Número impreso y usuario son obligatorios');
            return;
          }

          await RfidCardService.updateCard(
            ownerId,
            cardId,
            {
              userNumber,
              userName
            }
          );
          ToastService.success('Tarjeta actualizada');
          this.update({ editingCardId: null, editingCardUserNumber: '', editingCardUserName: '' });
          await this.loadCards();
        } catch (error) {
          console.error('Error updating card:', error);
          ToastService.error('Error al actualizar tarjeta');
        }
      },

      async toggleCard(event) {
        try {
          const cardId = event?.currentTarget?.dataset?.cardId;
          const card = this.getCardById(cardId);
          if (!card) {
            ToastService.error('No se pudo identificar la tarjeta');
            return;
          }

          await RfidCardService.toggleCard(this.getCardOwnerId(card), card._id);
          ToastService.success(`Tarjeta ${card.enabled ? 'deshabilitada' : 'habilitada'}`);
          await this.loadCards();
        } catch (error) {
          console.error('Error toggling card:', error);
          ToastService.error('Error al cambiar estado de tarjeta');
        }
      },

      confirmDelete(event) {
        const cardId = event?.currentTarget?.dataset?.cardId;
        const card = this.getCardById(cardId);
        if (!card) {
          ToastService.error('No se pudo identificar la tarjeta');
          return;
        }

        if (confirm(`¿Estás seguro de eliminar la tarjeta "${card.userName} (${card.cardNumber})"?`)) {
          this.deleteCard(card);
        }
      },

      async deleteCard(card) {
        try {
          await RfidCardService.deleteCard(this.getCardOwnerId(card), card._id);
          ToastService.success('Tarjeta eliminada');
          await this.loadCards();
        } catch (error) {
          console.error('Error deleting card:', error);
          ToastService.error('Error al eliminar tarjeta');
        }
      },

      downloadTemplate() {
        RfidCardService.downloadTemplate();
      },

      async handleBulkUploadComplete() {
        // Recargar tarjetas después de carga masiva
        await this.loadCards();

        // Cerrar modal
        const modalElement = document.getElementById('bulkUploadModal');
        if (modalElement) {
          const modal = Modal.getInstance(modalElement);
          if (modal) {
            modal.hide();
          }
        }
      },

      formatDate(dateString) {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      },

      formatRelativeTime(dateString) {
        if (!dateString) return 'Nunca';

        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 1) return 'Justo ahora';
        if (diffMins < 60) return `Hace ${diffMins} minuto${diffMins > 1 ? 's' : ''}`;
        if (diffHours < 24) return `Hace ${diffHours} hora${diffHours > 1 ? 's' : ''}`;
        if (diffDays < 30) return `Hace ${diffDays} día${diffDays > 1 ? 's' : ''}`;

        return this.formatDate(dateString);
      }
    };
  </script>

  <style>
    .rfid-card-manager {
      margin-top: 1rem;
    }

    .table code {
      background-color: #f8f9fa;
      padding: 0.2rem 0.4rem;
      border-radius: 0.25rem;
      font-size: 0.9em;
    }
  </style>
</rfid-card-manager>
